import * as types from './mutations_types.js'

export default {
  ADD_TO_CART: ({commit}, data) => {
    commit(types.ADD_TO_CART, data)
  },
  SAVE_ACTIVITY_ITEM: ({commit}, data) => {
    commit(types.SAVE_ACTIVITY_ITEM, data)
  },
  EDIT_TO_CART: ({commit}, data) => {
    commit(types.EDIT_TO_CART, data)
  },
  DELETE_TO_CART: ({commit}, data) => {
    commit(types.DELETE_TO_CART, data)
  },
  CHECKOUT: ({commit}, data) => {
    commit(types.CHECKOUT, data)
  },
  SAVE_TO_CART: ({commit}, data) => {
    commit(types.SAVE_TO_CART, data)
  }
}




// WEBPACK FOOTER //
// ./src/store/cart/actions.js